/**
 * The marks of paying online in the payment window of the licence (Furkan, 27/10/2026: "molie logosu olsa
 * guzelce altta"): Bancontact, KBC/CBC and Belfius as Mollie gives them to shops
 * (mollie.com/external/icons/payment-methods), and Mollie's word mark from mollie.com. Drawn here, not loaded: the
 * till shows no image of another address.
 */

export function BancontactMark() {
  return (
    <svg className="paymark" width="32" height="24" viewBox="0 0 32 24" fill="none" role="img" aria-label="Bancontact">
      <rect x="1" y="1" width="30" height="22" rx="3" fill="#fff" stroke="#E6E6E6" strokeWidth="1" />
      <path d="M9 17C12.6164 17 14.1918 14.411 16 12H4V17H9Z" fill="url(#paymark-bc-a)" />
      <path d="M23 7C19.3836 7 17.8082 9.58904 16 12H28V7H23Z" fill="url(#paymark-bc-b)" />
      <defs>
        <linearGradient
          id="paymark-bc-a"
          x1="6.42722"
          y1="14.4555"
          x2="15.2057"
          y2="11.1949"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005AB9" />
          <stop offset="1" stopColor="#1E3764" />
        </linearGradient>
        <linearGradient
          id="paymark-bc-b"
          x1="16.7265"
          y1="12.2401"
          x2="26.0475"
          y2="9.06004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBA900" />
          <stop offset="1" stopColor="#FFD800" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function KbcMark() {
  return (
    <svg className="paymark" width="32" height="24" viewBox="0 0 32 24" fill="none" role="img" aria-label="KBC/CBC">
      <rect x="1" y="1" width="30" height="22" rx="3" fill="#fff" stroke="#E6E6E6" strokeWidth="1" />
      <path
        d="M2.93513 5.86572C4.55625 5.86572 5.87031 4.5526 5.87031 2.93283C5.87031 1.31318 4.55625 0 2.93513 0C1.31406 0 0 1.31318 0 2.93283C0 4.5526 1.31406 5.86572 2.93513 5.86572Z"
        transform="translate(13.1467 5.01093)"
        fill="#019ACC"
      />
      <path
        d="M7.95233 1.37176C6.97069 1.37176 6.12532 0.990549 5.58772 0.566787C2.3832 0.902812 0 1.37907 0 1.37907V2.6261H17.0323C17.0323 0.875709 17.0323 0.000513809 17.0323 0.000513809C17.0323 0.000513809 14.0873 -0.0175251 10.7629 0.160166C10.2038 0.765873 9.21757 1.37176 7.95233 1.37176Z"
        transform="translate(7.48389 10.1565)"
        fill="#019ACC"
      />
      <path
        d="M2.01952 4.69565H0V0H2.01952V2.11308L3.21976 0H5.64116L3.86806 2.42663L5.54106 4.69565H3.23031L2.03344 2.9308L2.01952 4.69565Z"
        transform="translate(7.48389 13.5652)"
        fill="#003466"
      />
      <path
        d="M5.12815 4.44636C4.65155 4.60304 4.02519 4.69565 3.46474 4.69565C1.46681 4.69565 0 4.08412 0 2.30559C0 0.698329 1.42171 0 3.36519 0C3.90536 0 4.59145 0.0641953 5.12815 0.248707L5.12743 1.80553C4.72969 1.5461 4.33195 1.38439 3.76233 1.38439C3.02107 1.38439 2.28022 1.7775 2.28022 2.34808C2.28022 2.92016 3.01777 3.31191 3.76233 3.31191C4.32283 3.31191 4.72969 3.14477 5.12743 2.89729L5.12815 4.44636Z"
        transform="translate(19.356 13.5652)"
        fill="#003466"
      />
      <path
        fillRule="evenodd"
        d="M2.01946 1.99002H3.02527C3.41401 1.99002 3.56628 1.8142 3.56628 1.54457C3.56628 1.23558 3.41263 1.08132 3.05333 1.08132H2.01934L2.01946 1.99002ZM2.01946 3.74101H3.0724C3.46702 3.74101 3.60148 3.55856 3.60148 3.28907C3.60148 3.01945 3.4657 2.82575 3.0769 2.82575H2.01934L2.01946 3.74101ZM0 0H4.08228C5.14272 0 5.49026 0.46038 5.49026 1.17713C5.49026 1.97944 4.84808 2.32807 4.18838 2.36738V2.38063C4.86571 2.43989 5.52553 2.52526 5.52553 3.47226C5.52553 4.09058 5.17799 4.69565 4.01158 4.69565H0V0Z"
        transform="translate(13.4558 13.5652)"
        fill="#003466"
      />
    </svg>
  );
}

export function BelfiusMark() {
  return (
    <svg className="paymark" width="32" height="24" viewBox="0 0 32 24" fill="none" role="img" aria-label="Belfius">
      <rect width="32" height="24" rx="4" fill="#D50043" />
      <path
        fillRule="evenodd"
        d="M0 1.78118C0 0.797462 0.789207 0 1.78118 0H8.71882C9.70254 0 10.5 0.789207 10.5 1.78118V10.5H1.78118C0.797462 10.5 0 9.71079 0 8.71882V1.78118ZM2.25 3.66229V3.83771C2.25 4.21078 2.54774 4.5 2.91503 4.5H7.58497C7.96061 4.5 8.25 4.20348 8.25 3.83771V3.66229C8.25 3.28922 7.95226 3 7.58497 3H2.91503C2.53939 3 2.25 3.29652 2.25 3.66229ZM2.25 6.66229V6.83771C2.25 7.21078 2.54774 7.5 2.91503 7.5H7.58497C7.96061 7.5 8.25 7.20348 8.25 6.83771V6.66229C8.25 6.28922 7.95226 6 7.58497 6H2.91503C2.53939 6 2.25 6.29652 2.25 6.66229Z"
        transform="translate(10.75 6.75)"
        fill="#fff"
      />
    </svg>
  );
}

/** Mollie's word mark, in the colour of the text around it. */
export function MollieMark() {
  return (
    <svg className="molliemark" viewBox="0 0 54 16" role="img" aria-label="Mollie">
      <path
        fill="currentColor"
        d="M 40.708 3.355 C 41.634 3.355 42.384 2.604 42.384 1.678 C 42.384 0.751 41.634 0 40.708 0 C 39.783 0 39.033 0.751 39.033 1.678 C 39.033 2.604 39.783 3.355 40.708 3.355 Z M 22.84 5.218 C 19.875 5.218 17.468 7.634 17.468 10.598 C 17.468 13.562 19.88 15.978 22.84 15.978 C 25.8 15.978 28.212 13.562 28.212 10.598 C 28.212 7.634 25.805 5.218 22.84 5.218 Z M 22.84 13.433 C 21.282 13.433 20.014 12.164 20.014 10.604 C 20.014 9.043 21.282 7.774 22.84 7.774 C 24.398 7.774 25.666 9.043 25.666 10.604 C 25.666 12.164 24.398 13.433 22.84 13.433 Z M 11.459 5.206 C 11.598 5.206 11.733 5.212 11.872 5.223 C 13.045 5.324 14.123 5.866 14.91 6.75 C 15.697 7.628 16.133 8.763 16.133 9.943 L 16.133 15.759 L 13.564 15.759 L 13.564 9.87 C 13.559 8.713 12.604 7.768 11.442 7.768 C 11.375 7.768 11.303 7.773 11.23 7.779 C 10.191 7.885 9.32 8.869 9.32 9.932 L 9.32 15.759 L 6.751 15.759 L 6.751 9.887 C 6.746 8.724 5.796 7.773 4.635 7.773 C 4.568 7.773 4.495 7.779 4.423 7.784 C 3.39 7.891 2.513 8.875 2.513 9.943 L 2.513 15.759 L 0 15.759 L 0 9.87 C 0 7.298 2.094 5.206 4.663 5.206 C 5.947 5.206 7.17 5.743 8.053 6.677 C 8.935 5.738 10.163 5.206 11.459 5.206 Z M 32.166 0.252 L 29.598 0.252 L 29.598 15.771 L 32.166 15.771 Z M 34.511 0.252 L 37.08 0.252 L 37.08 15.771 L 34.511 15.771 Z M 41.994 5.475 L 39.425 5.475 L 39.425 15.765 L 41.994 15.765 Z M 52.508 6.728 C 53.469 7.706 53.999 8.992 53.999 10.357 L 53.999 11.537 L 46.187 11.537 C 46.533 12.779 47.661 13.651 48.968 13.651 C 49.99 13.651 50.911 13.131 51.441 12.253 L 51.548 12.08 L 53.67 13.125 L 53.547 13.332 C 52.581 14.96 50.81 15.972 48.923 15.972 L 48.917 15.972 C 47.477 15.972 46.125 15.401 45.103 14.367 C 44.081 13.332 43.529 11.968 43.545 10.525 C 43.562 9.11 44.121 7.784 45.115 6.783 C 46.108 5.782 47.438 5.223 48.845 5.206 L 48.912 5.206 C 50.269 5.206 51.542 5.749 52.508 6.728 Z M 51.402 9.412 C 51.034 8.316 49.984 7.544 48.811 7.544 C 47.639 7.544 46.589 8.316 46.226 9.412 Z"
      />
    </svg>
  );
}
